import React, { useEffect } from 'react';
import { Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationProgramSummary, fetchGraphics} from 'app/actions/CommunicationProgramKeyUserActions';
import { getCommunicationsProgramKeyUserSummary, getIsLoadingCommunicationsProgramKeyUserSummary, getCommunicationKeyUserGraphics, getCommunicationsProgramKeyUserSummaryFilters } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import isEmpty from 'app/utils/IsEmpty';
import { T } from 'antd/lib/upload/utils';
export default function CommunicationProgramSummaryContainer(props) {
    const { classes } = props;
    const dispatch = useDispatch();

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;
    const eachChild = [['contractName', 'Finalizados', 'Pendientes']];
    const chartPieArray = [['Task', 'Percent']];
    const subdirectionId = props.subdirectionId;
    const isOilService = props.subdirectionId === 3;

    let communicationProgramSummary = useSelector(getCommunicationsProgramKeyUserSummary);
    let isLoading = useSelector(getIsLoadingCommunicationsProgramKeyUserSummary);
    const graphics = useSelector(getCommunicationKeyUserGraphics)
    const filters = useSelector(getCommunicationsProgramKeyUserSummaryFilters)

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const {
        siteId
    } = useSelector(state => state.Auth);

    const {
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const columnsOilService = [
        {
            title: 'PDC',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 300,
            ellipsis: true,
            onCell: () => {
                return {
                    style: {
                        whiteSpace: 'nowrap',
                        maxWidth: 150,
                    }
                }
            },
            // render: (text) => (
            //     <Tooltip title={text}>
            //         <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{text}</div>
            //     </Tooltip>
            // )
        },
        {
            title: 'Contrato',
            dataIndex: 'contractName',
            key: 'contractName',
            sorter: true,
            ellipsis: true,
            width: 150

        },
        {
            title: 'OT',
            dataIndex: 'workName',
            key: 'workName',
            sorter: true,
            width: 150

        },

        {
            title: 'Pendientes',
            dataIndex: 'pending',
            key: 'pending',
            sorter: true,
            width: 120

        },
        {
            title: 'Comunicado',
            dataIndex: 'communicated',
            key: 'communicated',
            sorter: true,
            width: 120
        },
        {
            title: 'Aprobados',
            dataIndex: 'finished',
            key: 'finished',
            sorter: true,
            width: 120
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            sorter: true,
            width: 120
        },
        {
            title: 'Avance',
            dataIndex: 'progressPercentage',
            key: 'progressPercentage',
            sorter: true,
            width: 130,
            render: (text, record) => (
                text ? text + ' %' : '0%'
            )
        },
        {
            width: '100%'
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idCommunicationProgram',
            fixed: 'right',
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip placement="bottom" title={'Detalle'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(record)}>
                            <Icon type="info-circle" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const columns = [
        {
            title: 'PDC',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 350,
            ellipsis: true,
            onCell: () => {
                return {
                    style: {
                        whiteSpace: 'nowrap',
                        maxWidth: 150,
                    }
                }
            },
            // render: (text) => (
            //     <Tooltip title={text}>
            //         <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{text}</div>
            //     </Tooltip>
            // )
        },
        {
            title: 'Pendientes',
            dataIndex: 'pending',
            key: 'pending',
            sorter: true,
            width: 170

        },
        // {
        //     title: 'Comunicado',
        //     dataIndex: 'communicated',
        //     key: 'communicated',
        //     sorter: true,
        //     width: 170,
        //     render: (text, record) => (
        //         <div>
        //             {
        //                 record.idTraining === 'TK0000000001' ? text : 'N/A'
        //             }
        //         </div>
        //     )
        // },
        {
            title: 'Aprobados',
            dataIndex: 'finished',
            key: 'finished',
            sorter: true,
            width: 170
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            sorter: true,
            width: 170
        },
        {
            title: 'Avance',
            dataIndex: 'progressPercentage',
            key: 'progressPercentage',
            sorter: true,
            width: 180
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idCommunicationProgram',
            fixed: 'right',
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip placement="bottom" title={'Detalle'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(record)}>
                            <Icon type="info-circle" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showTabEdit = (row) => {
        props.setVisible(true);
        props.setRowData(row)
    }

    const detrmineRolSite = () => {
        //Regla 17.03.2022 Rivera: Si es admin abordo => tipo de capacitacion D.O; Admin Tierra => Sus tipos de capacitacion
        for (const rol of Roles) {
            if (rol.NameRole.includes('Administrador'))
                return siteId;
        }
        return '';
    }

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    useEffect(() => {

        if (isEmpty(communicationProgramSummary)) fetchCommunicationProgramSummaryAction();
        if (isEmpty(graphics)) fetchGraphsActions();

    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        var respnse = IsSuperAdmin();

        dispatch(fetchCommunicationProgramSummary(
            {
                SubdirectionId: subdirectionId,
                FrontId: props.front,
                CommunicationProgramId: props.cp,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize,
                trainingId: props.training,
                rolSite: !props.training.length ? detrmineRolSite() : '',
                employeeId: employeeId,
                EsSuperAdmin: respnse ? 1 : 0
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && communicationProgramSummary.length > 0) {
            pagination.total = communicationProgramSummary[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchCommunicationProgramSummaryAction = () => {

        var respnse = IsSuperAdmin();

        dispatch(fetchCommunicationProgramSummary({
            sortColumn: 'IdCommunicationProgram',
            sortDir: 'DESC',
            offset: offset,
            limit: limit == 0 ? 25 : limit,
            subdirectionId: subdirectionId,
            rolSite: detrmineRolSite(),
            employeeId: employeeId,
            EsSuperAdmin: respnse ? 1 : 0
        }))

    };
    const fetchGraphsActions = () => {
        var respnse = IsSuperAdmin();
        dispatch(fetchGraphics({
            SubdirectionId: subdirectionId,
            rolSite: detrmineRolSite(),
            employeeId: employeeId,
            EsSuperAdmin: respnse ? 1 : 0
        }));
    }

    if (typeof graphics.DataContract !== 'undefined') graphics.DataContract.forEach(i => {
        eachChild.push([String(i.contractName), i.totalFinished, i.totalPending])
    })

    if (typeof graphics.DataGraphics !== 'undefined') {
        chartPieArray.push(['Finalizados', graphics.DataGraphics.GeneralFinished], ['Pendientes/Proceso', graphics.DataGraphics.GeneralPending],)
    }
    
    return (props.children({ pagination: pagination, cols: (isOilService ? columnsOilService : columns), communicationProgramSummary, filters, isLoading, handleTableChange: handleTableChange, eachChild, chartPieArray, graphics }));
}


